import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Typography, Box,
  TextField, InputAdornment, MenuItem, Grid
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const months = [
  { value: '', label: 'All Months' },
  { value: 0, label: 'January' },
  { value: 1, label: 'February' },
  { value: 2, label: 'March' },
  { value: 3, label: 'April' },
  { value: 4, label: 'May' },
  { value: 5, label: 'June' },
  { value: 6, label: 'July' },
  { value: 7, label: 'August' },
  { value: 8, label: 'September' },
  { value: 9, label: 'October' },
  { value: 10, label: 'November' },
  { value: 11, label: 'December' },
];

const UserData = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [filterMonth, setFilterMonth] = useState('');
  const [filterDate, setFilterDate] = useState('');

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const res = await axios.get('https://reviewhub-lc.onrender.com/api/auth/users');
      setUsers(res.data);
    } catch (err) {
      console.error('Failed to fetch users:', err);
    }
  };

  const filteredUsers = users.filter(user => {
    const signup = new Date(user.signupDate);
    const matchSearch = user.username.toLowerCase().includes(search.toLowerCase());
    const matchMonth = filterMonth === '' || signup.getMonth() === Number(filterMonth);
    const matchDate = filterDate === '' || signup.getDate() === Number(filterDate);
    return matchSearch && matchMonth && matchDate;
  });

  return (
    <Box
      sx={{
        minHeight: '90vh',
        background: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        padding: 0
      }}
    >
      <TableContainer
        component={Paper}
        elevation={10}
        sx={{
          backdropFilter: 'blur(12px)',
          background: 'rgba(255, 255, 255, 0.75)',
          borderRadius: '20px',
          padding: 3,
          width: '100%',
          maxWidth: 1000
        }}
      >
        <Typography
          variant="h4"
          sx={{
            textAlign: 'center',
            fontWeight: '700',
            mb: 3,
            color: '#2c3e50'
          }}
        >
          Users List
        </Typography>

        {/* Filters */}
        <Grid container spacing={2} mb={3}>
          <Grid item xs={12} sm={4}>
            <TextField
              fullWidth
              placeholder="Search by username"
              variant="outlined"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="action" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              select
              fullWidth
              label="Filter by Month"
              value={filterMonth}
                sx={{width:180 }}
              onChange={(e) => setFilterMonth(e.target.value)}
            >
              {months.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item xs={6} sm={4}>
            <TextField
              fullWidth
              type="number"
              label="Filter by Date"
              value={filterDate}
                   sx={{width:180 }}
              onChange={(e) => {
                const val = e.target.value;
                setFilterDate(val === '' ? '' : Math.min(31, Math.max(1, Number(val))));
              }}
              inputProps={{ min: 1, max: 31 }}
            />
          </Grid>
        </Grid>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ fontWeight: 'bold', color: '#34495e' }}>#</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold', color: '#34495e' }}>Username</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold', color: '#34495e' }}>Email</TableCell>
              <TableCell align="center" sx={{ fontWeight: 'bold', color: '#34495e' }}>Signup Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredUsers.map((user, index) => (
              <TableRow
                key={user._id}
                hover
                sx={{
                  '&:hover': {
                    backgroundColor: '#f0f0f0',
                    cursor: 'pointer',
                  },
                }}
              >
                <TableCell align="center">{index + 1}</TableCell>
                <TableCell align="center">{user.username}</TableCell>
                <TableCell align="center">{user.email}</TableCell>
                <TableCell align="center">
                  {new Date(user.signupDate).toLocaleString('en-IN', {
                    day: 'numeric',
                    month: 'short',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default UserData;
